import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';
import PayrollPositionForm from './PayrollPositionForm';

const PayrollPositionModal = props => (
  <Provider store={store}>
    <PayrollPositionForm {...props} />
  </Provider>
);

export default PayrollPositionModal;
